export const translationsPrefix =
  'configuration.rolesAndPermissions.users.table.headers.accessLevel.profiles.detail'
